module.exports = __webpack_public_path__ + "img/tip.68266047.png";